import { Injectable, inject } from '@angular/core';
import { FirebaseAuthService } from '@firebase/firebase-auth.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GoChatCacheService {
  private firebaseAuth = inject(FirebaseAuthService);

  /**
   * Calculates the cache key by concatenating the cache prefix and the logged-in user's ID.
   * This is the structure of the key that is defined in GoCore.
   * @returns The chat cache key in the format of "'chat-cache-' + [logged-in user ID]".
   */
  private async calculateCacheKey(): Promise<string> {
    const CACHE_KEY_PREFIX = 'chat-cache-';

    const loggedInUserId: string = (await firstValueFrom(this.firebaseAuth.user$)).uid;
    return CACHE_KEY_PREFIX + loggedInUserId;
  }

  /**
   * Deletes the chat cache for the currently logged-in user.
   */
  public async deleteChatCache(): Promise<void> {
    const chatCacheKey: string = await this.calculateCacheKey();

    localStorage.removeItem(chatCacheKey);
  }
}
